import { AutoSuggest } from "../../ui/auto.suggest";
var AutoSuggestComponent = /** @class */ (function () {
    function AutoSuggestComponent(options) {
        this.options = options;
        // this.id = this.options.id ?? helper.newDomGuid();
    }
    AutoSuggestComponent.prototype.render = function () {
        var _a;
        return {
            tag: "input",
            attr: { value: this.options.value, class: this.options.class, style: this.options.style, placeholder: (_a = this.options.placeholder) !== null && _a !== void 0 ? _a : "" }
        };
    };
    AutoSuggestComponent.prototype.getRef = function () {
        return this.ref;
    };
    AutoSuggestComponent.prototype.getValue = function () {
        if (this.dom == null) {
            return "";
        }
        return this.dom.value;
    };
    AutoSuggestComponent.prototype.setValue = function (val) {
        if (this.dom == null) {
            return;
        }
        this.dom.value = val;
    };
    AutoSuggestComponent.prototype.focus = function () {
        if (this.dom == null) {
            return;
        }
        this.dom.focus();
    };
    AutoSuggestComponent.prototype.onCreate = function (node) {
        this.dom = node.dom;
        AutoSuggest(node.dom, this.options);
    };
    AutoSuggestComponent.prototype.onUpdate = function (node) {
        this.dom = node.dom;
    };
    AutoSuggestComponent.prototype.onRemove = function () {
        if (this.ref != null) {
            this.ref.destroy();
        }
    };
    return AutoSuggestComponent;
}());
export { AutoSuggestComponent };
